import uiRouter from 'angular-ui-router';
import createQuestionTpl from './views/createQuestion.html';
import createQuestionCtrl from './controllers/createQuestionController';
import aslAudioTpl from './views/aslAudio.html';
import aslAudioCtrl from './controllers/aslAudioController';
import aslFibTpl from './views/aslFib.html';
import aslFibCtrl from './controllers/aslFibController';
import aslListenTpl from './views/aslListen.html';
import aslListenCtrl from './controllers/aslListenController';
import aslMcqTpl from './views/aslMcq.html';
import aslMcqCtrl from './controllers/aslMcqController';
import aslSpeakTpl from './views/aslSpeak.html';
import aslSpeakCtrl from './controllers/aslSpeakController';
import aslTextTpl from './views/aslText.html';
import aslTextCtrl from './controllers/aslTextController';
import aslTfTpl from './views/aslTf.html';
import aslTfCtrl from './controllers/aslTfController';
import aslVoiceRecordTpl from './views/aslVoiceRecord.html';
import aslVoiceRecordCtrl from './controllers/aslVoiceRecordController';
import drawTpl from './views/draw.html';
import drawCtrl from './controllers/drawController';
import fibBulkUploadTpl from './views/fibBulkUpload.html';
import fibBulkUploadCtrl from './controllers/fibBulkUploadController';
import fibTpl from './views/fib.html';
import fibCtrl from './controllers/fibController';
import longBulkUploadTpl from './views/longBulkUpload.html';
import longBulkUploadCtrl from './controllers/longBulkUploadController';
import longTpl from './views/long.html';
import longCtrl from './controllers/longController';
import matchBulkUploadTpl from './views/matchBulkUpload.html';
import matchBulkUploadCtrl from './controllers/matchBulkUploadController';
import matchTpl from './views/match.html';
import matchCtrl from './controllers/matchController';
import mcqBulkUploadTpl from './views/mcqBulkUpload.html';
import mcqBulkUploadCtrl from './controllers/mcqBulkUploadController';
import mcqTpl from './views/mcq.html';
import mcqCtrl from './controllers/mcqController';
import owqBulkUploadTpl from './views/owqBulkUpload.html';
import owqBulkUploadCtrl from './controllers/owqBulkUploadController';
import owqTpl from './views/owq.html';
import owqCtrl from './controllers/owqController';
import passageTpl from './views/passage.html';
import passageCtrl from './controllers/passageController';
import shortBulkUploadTpl from './views/shortBulkUpload.html';
import shortBulkUploadCtrl from './controllers/shortBulkUploadController';
import shortTpl from './views/short.html';
import shortCtrl from './controllers/shortController';
import tfBulkUploadTpl from './views/tfBulkUpload.html';
import tfBulkUploadCtrl from './controllers/tfBulkUploadController';
import tfTpl from './views/tf.html';
import tfCtrl from './controllers/tfController';
import './createQuestion.scss';
import _ from "underscore";

var module = angular.module('CreateQuestionModule', [
    uiRouter
    //import modules
]).component("createQuestion", {
    template: createQuestionTpl,
    controller: createQuestionCtrl,
    controllerAs: 'createQuestion'
}).component("aslAudio", {
    template: aslAudioTpl,
    controller: aslAudioCtrl,
    controllerAs: 'aslAudio'
}).component("aslListen", {
    template: aslListenTpl,
    controller: aslListenCtrl,
    controllerAs: 'aslListen'
}).component("aslFib", {
    template: aslFibTpl,
    controller: aslFibCtrl,
    controllerAs: 'aslFib'
}).component("aslMcq", {
    template: aslMcqTpl,
    controller: aslMcqCtrl,
    controllerAs: 'aslMcq'
}).component("aslSpeak", {
    template: aslSpeakTpl,
    controller: aslSpeakCtrl,
    controllerAs: 'aslSpeak'
}).component("aslText", {
    template: aslTextTpl,
    controller: aslTextCtrl,
    controllerAs: 'aslText'
}).component("aslTf", {
    template: aslTfTpl,
    controller: aslTfCtrl,
    controllerAs: 'aslTf'
}).component("aslVoiceRecord", {
    template: aslVoiceRecordTpl,
    controller: aslVoiceRecordCtrl,
    controllerAs: 'aslVoiceRecord'
}).component("draw", {
    template: drawTpl,
    controller: drawCtrl,
    controllerAs: 'draw'
}).component("fibBulkUpload", {
    template: fibBulkUploadTpl,
    controller: fibBulkUploadCtrl,
    controllerAs: 'fibBulkUpload'
}).component("fib", {
    template: fibTpl,
    controller: fibCtrl,
    controllerAs: 'fib'
}).component("longBulkUpload", {
    template: longBulkUploadTpl,
    controller: longBulkUploadCtrl,
    controllerAs: 'longBulkUpload'
}).component("long", {
    template: longTpl,
    controller: longCtrl,
    controllerAs: 'long'
}).component("matchBulkUpload", {
    template: matchBulkUploadTpl,
    controller: matchBulkUploadCtrl,
    controllerAs: 'matchBulkUpload'
}).component("match", {
    template: matchTpl,
    controller: matchCtrl,
    controllerAs: 'match'
}).component("mcqBulkUpload", {
    template: mcqBulkUploadTpl,
    controller: mcqBulkUploadCtrl,
    controllerAs: 'mcqBulkUpload'
}).component("mcq", {
    template: mcqTpl,
    controller: mcqCtrl,
    controllerAs: 'mcq'
}).component("owqBulkUpload", {
    template: owqBulkUploadTpl,
    controller: owqBulkUploadCtrl,
    controllerAs: 'owqBulkUpload'
}).component("owq", {
    template: owqTpl,
    controller: owqCtrl,
    controllerAs: 'owq'
}).component("passage", {
    template: passageTpl,
    controller: passageCtrl,
    controllerAs: 'passage'
}).component("shortBulkUpload", {
    template: shortBulkUploadTpl,
    controller: shortBulkUploadCtrl,
    controllerAs: 'shortBulkUpload'
}).component("short", {
    template: shortTpl,
    controller: shortCtrl,
    controllerAs: 'short'
}).component("tfBulkUpload", {
    template: tfBulkUploadTpl,
    controller: tfBulkUploadCtrl,
    controllerAs: 'tfBulkUpload'
}).component("tf", {
    template: tfTpl,
    controller: tfCtrl,
    controllerAs: 'tf'
}).controller('createQuestionCtrl', createQuestionCtrl);

module.constant("CQuesConst", {
    VALUE_POINTS_LIMIT: 500,
    QUES_DESC_LIMIT: 1000,
    OPTION_LIMIT: 200,
    ANS_EXPLANATION_LIMIT:500,
    SKILL_LIST: ["Analysing", "Applying", "Creating", "Evaluating", "Recall", "Understanding"],
    QUESTION_IMG_SUPPORT_FORMAT: ['jpg', 'jpeg', 'png'],
    API_GET_BASIC_DETAILS: "/v0/ques-create/get-basic-details",
    API_GET_ALL_PASSAGES: "/v0/ques-create/get-passage-list",
    API_GET_QUESTION: "/v0/archives/preview/question/",
    API_OWQ_SAVE: "/v0/ques-create/owq",
    QUESTION_TYPE_LIST: [{
        name: "Multiple Choice Question",
        _id: "MCQ",
        isPractice: true
    }, {
        name: "Fill in the Blanks",
        _id: "FIB",
        isPractice: true
    }, {
        name: "True or False",
        _id: "TF",
        isPractice: true
    }, {
        name: "One Word Question",
        _id: "OWQ",
        isPractice: true
    }, {
        name: "Match the Following",
        _id: "MTF",
        isPractice: true
    }, {
        name: "Short Answer",
        _id: "SA",
        isPractice: false
    }, {
        name: "Long Answer",
        _id: "LA",
        isPractice: false
    }, 
    /*{
        name: "Drawing",
        _id: "DRAW",
        isPractice: false
    }, {
        name: "Asl - Listening",
        _id: "ASLLISTEN",
        isPractice: false
    }, {
        name: "Asl - Speaking",
        _id: "ASLSPEAK",
        isPractice: false
    },*/ 
    {
        name: "Passage",
        _id: "passage",
        isPractice: false
    }],
    ASL_ANS_TYPE : {
        AUDIO: "audio",
        MCQ: "mcq",
        FIB: "fib",
        TF: "tf",
        TEXT: "text"
    },
    API_CREATE_MCQ: "/v0/ques-create/mcq",
    API_CREATE_FIB: "/v0/ques-create/fib",
    API_CREATE_TF: "/v0/ques-create/tf",
    API_CREATE_MTF: "/v0/ques-create/mtf",
    API_CREATE_SA: "/v0/ques-create/sa",
    API_CREATE_LA: "/v0/ques-create/la",
    API_CREATE_DRAW: "/v0/ques-create/draw",
    API_CREATE_ASL_LISTEN: "/v0/ques-create/asl-listen",
    API_CREATE_ASL_SPEAK: "/v0/ques-create/asl-speak",
    API_CREATE_BULK_MCQ: "/v0/ques-create/bulk/mcq",
    API_CREATE_BULK_FIB: "/v0/ques-create/bulk/fib",
    API_CREATE_BULK_LA: "/v0/ques-create/bulk/la",
    API_CREATE_BULK_OWQ: "/v0/ques-create/bulk/owq",
    API_CREATE_BULK_SA: "/v0/ques-create/bulk/sa",
    API_CREATE_BULK_TF: "/v0/ques-create/bulk/tf",
    API_CREATE_BULK_MTF: "/v0/ques-create/bulk/mtf",
    API_CREATE_PASSAGE: "/v0/ques-create/passage"
    
    
  
})

module.config(function($stateProvider) {
    "ngInject";

    /*$stateProvider
        .state('createQuestion', {
            parent: 'app',
            url: '/createQuestion',
            views: {
                '@': {
                    template: createQuestionTpl,
                    controller: createQuestionCtrl,
                    controllerAs: 'createQuestion'
                }
            }
        })*/
});



// WEBPACK FOOTER //
// ./src/app/createQuestion/createQuestionModule.js